/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * Standard error response object
 */
export type PutApiWorkspaceServiceV1AccountsErrorResponseData = {
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;
};

/**
 * Standard error response object
 */
export class PutApiWorkspaceServiceV1AccountsErrorResponse extends Error {
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;

  /** The original data that was passed to this error instance. */
  data$: PutApiWorkspaceServiceV1AccountsErrorResponseData;

  constructor(err: PutApiWorkspaceServiceV1AccountsErrorResponseData) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.error = err.error;
    if (err.code != null) this.code = err.code;
    if (err.details != null) this.details = err.details;

    this.name = "PutApiWorkspaceServiceV1AccountsErrorResponse";
  }
}

/** @internal */
export const PutApiWorkspaceServiceV1AccountsErrorResponse$inboundSchema:
  z.ZodType<
    PutApiWorkspaceServiceV1AccountsErrorResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    error: z.string(),
    code: z.string().optional(),
    details: z.nullable(z.any()).optional(),
  })
    .transform((v) => {
      return new PutApiWorkspaceServiceV1AccountsErrorResponse(v);
    });

/** @internal */
export type PutApiWorkspaceServiceV1AccountsErrorResponse$Outbound = {
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;
};

/** @internal */
export const PutApiWorkspaceServiceV1AccountsErrorResponse$outboundSchema:
  z.ZodType<
    PutApiWorkspaceServiceV1AccountsErrorResponse$Outbound,
    z.ZodTypeDef,
    PutApiWorkspaceServiceV1AccountsErrorResponse
  > = z.instanceof(PutApiWorkspaceServiceV1AccountsErrorResponse)
    .transform(v => v.data$)
    .pipe(z.object({
      error: z.string(),
      code: z.string().optional(),
      details: z.nullable(z.any()).optional(),
    }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PutApiWorkspaceServiceV1AccountsErrorResponse$ {
  /** @deprecated use `PutApiWorkspaceServiceV1AccountsErrorResponse$inboundSchema` instead. */
  export const inboundSchema =
    PutApiWorkspaceServiceV1AccountsErrorResponse$inboundSchema;
  /** @deprecated use `PutApiWorkspaceServiceV1AccountsErrorResponse$outboundSchema` instead. */
  export const outboundSchema =
    PutApiWorkspaceServiceV1AccountsErrorResponse$outboundSchema;
  /** @deprecated use `PutApiWorkspaceServiceV1AccountsErrorResponse$Outbound` instead. */
  export type Outbound = PutApiWorkspaceServiceV1AccountsErrorResponse$Outbound;
}
